export default __webpack_public_path__ + "static/media/create-account.8ddb6213.png";